import React from 'react'
import Fragment from '../common/fragment'


function FragmentDW(props) {
  return (
    <Fragment pos="wwww" {...props}>
      <p>
Señora de las Abejas: abre la puerta de las colmenas,
te llevaremos miel en cántaros, iremos zumbando como

tus hijas, a pie entre los álamos, bajo la sombra de las
chimeneas, cargando dulzura, bayas del campo, luz de
la tarde, flautas mágicas, helados, convulsiones, la cera
derretida de los muñecos. Como abejas, a pie entre los
charcos. Seres de aire. Seres zumbantes. Señora: la miel
la tomamos de tus hijas, pero se la devolveremos en
días venideros. Todo es propiedad privada. Vallas y
alambres. No pasar. Cuidado con los charcos. Espejos
humeantes.
      </p>
    </Fragment>
  )
}


export default FragmentDW
